/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as PlayState from './state.defs.js'

const $nsid = 'at.tastetest.play.edit'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  league: /*#__PURE__*/ l.string(),
  expectedRound: /*#__PURE__*/ l.integer({ minimum: 1, maximum: 20 }),
  expectedPlans: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<PlayState.PlannedRound>(
      (() => PlayState.plannedRound) as any,
    ),
    { maxLength: 19 },
  ),
  plannedRounds: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<PlayState.PlannedRound>(
      (() => PlayState.plannedRound) as any,
    ),
    { maxLength: 19 },
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  ok: /*#__PURE__*/ l.boolean(),
  message: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxGraphemes: 300 }),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
